import { HttpClient } from '@/api/services/http/client';

export interface PrebuiltAction {
  id: string;
  name: string;
  description: string;
  icon: string;
  category: string;
  actionCount: number;
  color: string;
}

export interface PrebuiltActionsResponse {
  data: PrebuiltAction[];
  total: number;
  page: number;
  limit: number;
}

export interface PrebuildSelectedAppsResponse {
  data: PrebuiltAction[];
}

export interface GeneratePrebuildAppConnectionsResponse {
  redirectUrl: string;
}

class PrebuiltActionsService {
  private baseUrl = '/pre-build-actions';

  async getPrebuiltActions(): Promise<PrebuiltActionsResponse> {
    const response = await HttpClient.apiClient.get(this.baseUrl);
    return response.data;
  }

  async getPrebuildSelectedApps(): Promise<PrebuildSelectedAppsResponse> {
    const response = await HttpClient.apiClient.get(`${this.baseUrl}/selected-apps`);
    return response.data;
  }

  async generatePrebuildAppConnections(toolName: string): Promise<GeneratePrebuildAppConnectionsResponse> {
    const response = await HttpClient.apiClient.post(`${this.baseUrl}/generate-prebuild-app-connections`, {
      toolName
    });
    return response.data;
  }
}

export const prebuiltActionsService = new PrebuiltActionsService(); 